import type { QueryClient } from '@tanstack/react-query';
import type { ApiProblem } from '@dhuttu/ui';
import { parseProblem } from './errors';

export function registerErrorHandlers(qc: QueryClient, opts: {
  onUnauthorized: () => void;
  onForbidden: (p: ApiProblem | null) => void;
}) {
  const handle = async (err: unknown) => {
    const status = (err as { response?: { status: number } }).response?.status;
    if (status === 401) opts.onUnauthorized();
    else if (status === 403) opts.onForbidden(await parseProblem(err));
  };
  qc.getQueryCache().subscribe((event) => {
    if (event.type === 'updated' && event.query.state.status === 'error') {
      void handle(event.query.state.error);
    }
  });
  qc.getMutationCache().subscribe((event) => {
    if (event.type === 'updated' && event.mutation?.state.status === 'error') {
      void handle(event.mutation.state.error);
    }
  });
}
